<template>
<a-modal
    v-bind:open="showModal"
    width="320px"
    :closable="true"
    :footer="null"
    :mask-closable="true"
    :mask-style="{backdropFilter: 'blur(2px)'}"
    :keyboard="false"
    footer
    :destroyOnClose="true"
    @cancel="closeModal"
    centered
>
    <div class="confirm-modal">
        <div class="confirm-modal-body">
            <div class="confirm-modal-title">
                인증서를 발행하시겠습니까?
            </div>
            <div class="confirm-modal-desc">
                입력한 환자 번호로 알림 메시지를 전송합니다.
            </div>
        </div>
        <div class="modal-footer-area">
            <a-button
                class="confirm-cancel"
                size="large"
                @click="closeModal"
            >
                취소
            </a-button>
            <a-button
                type="primary"
                class="confirm-ok"
                @click="issueCertificate"
                size="large"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 18 18" fill="none">
                    <path d="M9.0025 1.125C4.03112 1.125 0 4.25326 0 8.10611C0 10.5048 1.56043 12.6186 3.93109 13.8779L2.93081 17.5409C2.84079 17.8657 3.21089 18.1255 3.49597 17.9356L7.87219 15.0323C8.24229 15.0672 8.61739 15.0872 8.9975 15.0872C13.9689 15.0872 18 11.959 18 8.10611C18 4.25326 13.9739 1.125 9.0025 1.125Z" fill="#2F3337"/>
                </svg>
                알림 메시지 전송
            </a-button>
        </div>
    </div>
</a-modal>
</template>
<script>

const readonly = {
    closeModal: 'closeModal',
    issueCertificate: 'issueCertificate',
}
export default {
    props: {
        showModal: {
            type: Boolean,
            required: true,
            default: false
        },
    },
    emits: [readonly.closeModal, readonly.issueCertificate],
    methods: {
        async issueCertificate() {
            this.$emit('issueCertificate');
        },
        closeModal() {
            this.$emit('closeModal', 'confirmModal', false);
        },
    }
}
</script>
<style lang="scss" scoped>
$Gray-5: #D1D6DB;
$Gray-10: #F1F2F3;
$Gray-20: #e8ebed;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-70: #6e747c;
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100 : #17191C;
$Yellow: #ffe414;
$SkyBlue : #E1F0FF;
$Blue : #278AEC;
$Red: #F55247;
$Pink: #F8948E;
$Orange: #FFA50A;
$Green: #22BF22;


$Font-medium: 500;
$Font-regular: 400;
$Font-semibold: 600;
$Font-bold: 700;
$Font-extrabold: 800;
$Font-heavy: 900;

.confirm-modal {
    .confirm-modal-body {
        display: flex;
        flex-direction: column;    
        text-align: center;
        padding: 46px 32px;
        height: auto;
        min-height: 148px;
        .confirm-modal-title {
            width: 100%;
            font-size: 20px;
            color: #2F3337;
            font-weight: bold;
            line-height: 1.2em;
            margin-bottom: 8px;
        }
        .confirm-modal-desc {
            color: #4B5158;
            line-height: 1.5em;
            font-size: 16px;
            font-weight: 400;
            word-break: keep-all;
        }
    }
    .modal-footer-area {
        display: flex;
        width: 100%;
        button {
            border-radius: 0;
        }
        .confirm-cancel {
            flex: 4;
        }
        .confirm-ok {
            flex: 6;
        }
        img {
            width: 20px;
        }
    }
}
</style>